import {
  LinkField,
  ActionField,
  MobileLinkField,
  ShareField,
} from "./components/CustomColumns/CustomColumns";
import React from "react";
import {
  formatRevenue,
  SHOW_TOTAL_VISITORS,
} from "features/Common/utils/common.utils";

export const columnConfig = (
  handleTrackingSummaryClick,
  handleViewBookingsClick,
  handleShare
) => [
  {
    field: "name",
    headerName: "Source Name",
    showInCard: true,
    noWrap: true,
    sortable: false,
    emptyField: "N/A",
    fixed: "left",
  },
  {
    isDrawerTitle: true,
    renderColumn: (record) => record?.name,
    hidden: true,
    hiddenDesktopColumn: true,
  },
  {
    field: "target",
    headerName: "Link directs to",
    showInCard: true,
    noWrap: true,
    sortable: false,
    emptyField: "N/A",
    ellipsis: true,
    maxCharCount: 30,
  },
  {
    field: "url",
    headerName: "URL",
    sortable: false,
    emptyField: "N/A",
    width: "188px",
    hidden: true,
    renderCell: (record) => <LinkField record={record} source="url" />,
  },
  ...(SHOW_TOTAL_VISITORS
    ? [
        {
          field: "total_visitors",
          headerName: "No. of visitors",
          showInCard: true,
          noWrap: true,
          sortable: false,
          emptyField: "N/A",
        },
      ]
    : []),
  {
    field: "leads",
    headerName: "Leads",
    showInCard: true,
    noWrap: true,
    sortable: false,
    emptyField: "N/A",
  },
  {
    field: "bookings",
    headerName: "Total Bookings",
    showInCard: true,
    noWrap: true,
    sortable: false,
    emptyField: "N/A",
  },
  {
    field: "total_revenue",
    headerName: "Total revenue",
    showInCard: true,
    noWrap: true,
    sortable: false,
    emptyField: "N/A",
    valueFormatter: (record) => formatRevenue(record?.total_revenue),
  },
  {
    headerName: "URL",
    hiddenDesktopColumn: true,
    isCollapsed: true,
    valueFormatter: (record) => (
      <MobileLinkField record={record} source="url" showShareIcon={false} />
    ),
  },
  {
    field: "tracking_summary",
    headerName: "Tracking Summary",
    showInCard: true,
    noWrap: true,
    sortable: false,
    emptyField: "N/A",
    isCollapsed: true,
    renderCell: (record) => (
      <ActionField
        record={record}
        onClick={handleTrackingSummaryClick}
        label="View Summary"
      />
    ),
    valueFormatter: (record) => (
      <ActionField
        record={record}
        onClick={handleTrackingSummaryClick}
        label="View Summary"
      />
    ),
  },
  {
    field: "",
    headerName: "View Bookings",
    noWrap: true,
    showInCard: true,
    sortable: false,
    emptyField: "N/A",
    isCollapsed: true,
    renderCell: (record) => (
      <ActionField
        record={record}
        onClick={handleViewBookingsClick}
        label={record.bookings ? "View Bookings" : "N/A"}
      />
    ),
    valueFormatter: (record) => (
      <ActionField
        record={record}
        onClick={handleViewBookingsClick}
        label={record.bookings ? "View Bookings" : "N/A"}
      />
    ),
  },
  {
    field: "",
    headerName: "Actions",
    renderCell: (record) => (
      <ShareField record={record} onClick={() => handleShare(record, "url")} />
    ),
    hidden: true,
    sortable: false,
    align: "center",
    fixed: "right",
  },
];

export const filterConfig = [
  {
    source: "name",
    placeholder: "Source Name",
    type: "input",
  },
  {
    source: "target",
    placeholder: "Link directs to",
    type: "input",
  },
];

export const tableChipsFormatter = (filter, value) => {
  switch (filter) {
    case "name__icontains":
      return `Name: ${value}`;
    case "target__icontains":
      return `Link directs to: ${value}`;
    default:
      return undefined;
  }
};
